import {React, useState, useEffect} from 'react';
import axios from 'axios';
import {Edit} from '@mui/icons-material';
import Progress from '../Progress';
import CompanyModifyOptions from '../forms/CompanyModifyOptions';
import Popup from '../Popup';
import Notification from '../Notification';
import ConfirmDialog from '../ConfirmDialog';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { updateTableActions } from '../../store/update-table-slice';
import CompanyDefinitionForm from '../forms/CompanyDefinitionForm';
 
let fetch_id = 0;
 
// Masking utility functions
const maskEmail = (email) => {
  if (!email) return '';
  const [username, domain] = email.split('@');
  if (!domain) return '*'.repeat(email.length);
  if (username.length <= 2) return `${'*'.repeat(username.length)}@${domain}`;
  return `${username[0]}${'*'.repeat(username.length - 2)}${username.slice(-1)}@${domain}`;
};
 
const maskPan = (pan) => {
  if (!pan) return '';
  if (pan.length <= 4) return '*'.repeat(pan.length);
  return `${'*'.repeat(pan.length - 4)}${pan.slice(-4)}`;
};
 
const maskTan = (tan) => {
  if (!tan) return '';
  if (tan.length <= 4) return '*'.repeat(tan.length);
  return `${'*'.repeat(tan.length - 4)}${tan.slice(-4)}`;
};
 
const maskTelephone = (telephone) => {
  if (!telephone) return '';
  if (telephone.length <= 4) return '*'.repeat(telephone.length);
  return `${telephone.slice(0, 2)}${'*'.repeat(telephone.length - 6)}${telephone.slice(-4)}`;
};
 
const maskPtReg = (ptReg) => {
  if (!ptReg) return '';
  if (ptReg.length <= 4) return '*'.repeat(ptReg.length);
  return `${'*'.repeat(ptReg.length - 4)}${ptReg.slice(-4)}`;
};
 
export default function CompanyMasterTable() {
 
  const [openPopup, setOpenPopup] = useState(false);
  const [companies, setCompanies] = useState([]);
  const [loading, setLoading] = useState(true);
  const [notify, setNotify] = useState({isOpen: false, message: '', type: ''});
  const [confirmDialog, setConfirmDialog] = useState({isOpen: false, title: '', subTitle: ''});
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const UPDATE_COMPANIES = useSelector(state => state.updateTable.updateCompanies);
 
  async function getAllCompanies(){
    try {
      const companies = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/company-master/view-companies`);
      setCompanies(companies.data);
    } catch (e) {
      if(e.response.status === 401) {
        setNotify({
          isOpen: true,
          message: 'Session Expired!',
          type: 'error'
        });
        setTimeout(() => {
          navigate('/');
        },1000);
      }
    }
    setLoading(false);
  }
 
  useEffect(()=>{
    getAllCompanies();
  }, []);
 
  useEffect(()=>{
    if(UPDATE_COMPANIES) {
      getAllCompanies();
      dispatch(updateTableActions.stopUpdateCompanies());
    }
  }, [UPDATE_COMPANIES]);
 
  const handleDelete = async (delete_id) => {
    setConfirmDialog({
      ...confirmDialog,
      isOpen: false
    });
    try {
      const res = await axios.delete(`${process.env.REACT_APP_API_BASE_URL}/company-master/delete-company/` + delete_id);
      getAllCompanies();
      if(res.status === 200) {
        setNotify({
          isOpen: true,
          message: 'Successfully Deleted!',
          type: 'error'
        });
        dispatch(updateTableActions.startUpdateCompanies());
      }
    } catch (e) {
      if(e.response.status === 401) {
        setNotify({
          isOpen: true,
          message: 'Session Expired!',
          type: 'error'
        });
        setTimeout(() => {
          navigate('/');
        },1000);
      }
      if(e.response.status === 422) {
        setNotify({
          isOpen: true,
          message: e.response.data.error_message,
          type: 'error'
        });
      }
    }
  }
 
  return (
    <>
    { loading ? <Progress/> :
      <div className="table-parent">
        <table class=" table big-table">
            <thead class="table-dark">
              <tr>
                <th scope="col" class="table-dark"></th>
               
                <th scope="col">Company Name</th>
                <th scope="col">Place</th>
                <th scope="col">Post Code</th>
                <th scope="col">City</th>
                <th scope="col">Street</th>
                <th scope="col">Locality</th>
                <th scope="col">Telephone</th>
                <th scope="col">Fax</th>
                <th scope="col">Payroll Manager</th>
                <th scope="col">E-mail</th>
                <th scope="col">State</th>
                <th scope="col">PT Registration No</th>
                <th scope="col">PAN no</th>
                <th scope="col">TAN no</th>
                <th scope="col">Name of Chief Finance Officer</th>
                <th scope="col">Finance Officer Father Name</th>
                <th scope="col">Designation</th>
              </tr>
            </thead>
            <tbody>
 
              {companies.map((company) => {
 
              return(
              <tr>
                <td><button type="button" class="btn btn-outline-primary btn-sm" onClick={() => {setOpenPopup(true); fetch_id = company.company_id;}} > <Edit/> Modify </button></td>
                <td>{company.company_name}</td>
                <td>{company.place}</td>
                <td>{company.post_code}</td>
                <td>{company.city}</td>
                <td>{company.street}</td>
                <td>{company.locality}</td>
                <td>{maskTelephone(company.telephone)}</td>
                <td>{maskTelephone(company.fax)}</td>
                <td>{company.payroll_manager}</td>
                <td>{maskEmail(company.email)}</td>
                <td>{company.state}</td>
                <td>{maskPtReg(company.pt_reg_no)}</td>
                <td>{maskPan(company.PAN_No)}</td>
                <td>{maskTan(company.TAN_No)}</td>
                <td>{company.Name_Of_Chief_Finance_Officer}</td>
                <td>{company.Fathers_Name}</td>
                <td>{company.Designation}</td>
              </tr>
            )
            })}
 
            </tbody>
          </table>
 
          <Popup
            title="Update"
            openPopup={openPopup}
            setOpenPopup={setOpenPopup}
          >
            <CompanyDefinitionForm title="Modify Company" fetch_id={fetch_id}/>
          </Popup>
 
    </div>}
        <Notification
            notify={notify}
            setNotify={setNotify} />
        <ConfirmDialog
          confirmDialog={confirmDialog}
          setConfirmDialog={setConfirmDialog} />
    </>
    
  );
}